import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'EncryptionPLG/EncryptionDemoStatus'

export const SUBMIT_ENCRYPTION_DEMO_REQUEST = createAsyncTypes(
  'SUBMIT_ENCRYPTION_DEMO_REQUEST',
  typeKey
)
